import { render } from "./ProjectionForm.vue?vue&type=template&id=f8fc489c&scoped=true"
import script from "./ProjectionForm.vue?vue&type=script&lang=js"
export * from "./ProjectionForm.vue?vue&type=script&lang=js"

import "./ProjectionForm.vue?vue&type=style&index=0&id=f8fc489c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8fc489c"]])

export default __exports__